module.exports = __webpack_public_path__ + "static/img/3.0843bef.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/3.png
// module id = 8z+Y
// module chunks = 1